import { em } from 'polished'
import styled, { css } from 'styled-components'

import { Text } from 'styles/components/typography'

import arrowGray from './assets/arrow-gray.svg'
import arrowWhite from './assets/arrow-white.svg'

export const FaqBg = styled.div`
  position: absolute;
  transition: ${({
    theme: {
      animation: { timeBtns, cubicBezier },
    },
  }) => `opacity ${timeBtns} ${cubicBezier}`};
  border-radius: ${p => p.theme.blocks.blockBorderRadiusForm};
  user-select: none;
  opacity: 0;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  margin: auto;

  &:after {
    background-size: contain;
    bottom: 0;
    content: '';
    height: ${em(17)};
    left: -${em(9)};
    position: absolute;
    width: ${em(26)};
  }
`

export const FaqLabel = styled.div`
  position: relative;
  transition: ${({
    theme: {
      animation: { timeBtns, cubicBezier },
    },
  }) => `transform ${timeBtns} ${cubicBezier}`};
`

export const TextStyled = styled(Text)``

export const Article = styled.article`
  position: relative;
  margin-left: ${em(20)};
  margin-right: ${em(20)};
  margin-bottom: ${em(20)};

  &:focus{
    outline: none;
  }

  &:before {
    background: transparent;
    content: "";
    transition: ${({
      theme: {
        animation: { timeBtns, cubicBezier },
      },
    }) =>
      `background ${timeBtns} ${cubicBezier}, transform ${timeBtns} ${cubicBezier}, width ${timeBtns} ${cubicBezier}`};
    height: 1px;
    position: absolute;
    top: 0;
    width: calc(100% - ${em(30)});
  }

  ${p => p.theme.mq.upMd} {
    margin: 0;

    &:before {
      transform: translateX(${em(30)});
    }
  }

  ${({ isActive, tabIndex, isNextToActive }) =>
    !isActive &&
    !!tabIndex &&
    !isNextToActive &&
    css`
      &:before {
        background: ${p => p.theme.colors.blackOp1};

        ${p => p.theme.mq.upMd} {
          transform: translateX(0);
          width: 100%;
        }
      }
    `}

  ${({ isActive }) =>
    isActive &&
    css`
      ${FaqBg} {
        opacity: 1;
      }

      ${FaqLabel} {
        ${TextStyled} {
          cursor: default;
        }

        ${p => p.theme.mq.upMd} {
          transform: translateX(${em(30)});
        }
      }
    `}

  ${({ color }) =>
    color === 'white' &&
    css`
    ${FaqBg} {
      background-color: ${p => p.theme.colors.white};

      &:after {
        background: url('${arrowWhite}') no-repeat 100% 100%;
      }
    }
  `}

  ${({ color }) =>
    color === 'gray' &&
    css`
    ${FaqBg} {
      background-color: ${p => p.theme.colors.grayOp06NonTransp};

      &:after {
        background: url('${arrowGray}') no-repeat 100% 100%;
      }
    }
  `}
`
